<template>
  <div>
    <icon-view
      icon="fas fa-plus-circle text-orange"
      icon-background="white"
      title="Propiedades del Libro"
    />
    <div class="row mt-3">
      <div class="col-12 col-md">
        <div class="form-group">
          <validation-provider
            mode="eager"
            rules="required"
            v-slot="{ errors }"
          >
            <custom-drop-down
              v-model="model.publisher"
              :disabled="addingProcess"
              :options="publishers"
              label="Casa Editorial:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="w-100 bold-label"
              :error="errors[0]"
              custom-error-msg="Este campo es requerido"
            />
          </validation-provider>
        </div>
      </div>
      <div class="col-12 col-md">
        <div class="form-group">
          <validation-provider
            mode="eager"
            rules="required"
            v-slot="{ errors }"
          >
            <custom-drop-down
              v-model="model.author"
              :disabled="addingProcess"
              :options="authors"
              label="Autor:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="w-100 bold-label"
              :error="errors[0]"
              custom-error-msg="Este campo es requerido"
            />
          </validation-provider>
        </div>
      </div>
      <div class="col-12 col-md">
        <div class="form-group">
          <validation-provider
            mode="eager"
            rules="required"
            v-slot="{ errors }"
          >
            <custom-drop-down
              v-model="model.readingMedium"
              :options="readingMediums"
              label="Medio de Lectura:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="w-100 bold-label"
              :error="errors[0]"
              custom-error-msg="Este campo es requerido"
            />
          </validation-provider>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md">
        <div class="form-group">
          <validation-provider
            mode="eager"
            rules="required"
            v-slot="{ errors }"
          >
            <custom-input
              v-model="model.isbn"
              :disabled="addingProcess"
              type="text"
              label="ISBN:"
              custom-error-msg="Este campo es requerido"
              :error="errors[0]"
            />
          </validation-provider>
        </div>
      </div>
      <div class="col-12 col-md"></div>
      <div class="col-12 col-md"></div>
    </div>
  </div>
</template>

<script>
import IconView from "icon-view";
import CustomDropDown from "custom-drop-down";
import CustomInput from "CustomInput";

export default {
  name: "Properties",
  components: {
    IconView,
    CustomDropDown,
    CustomInput
  },
  props: {
    publishers: {
      type: Array,
      require: true,
      default: () => []
    },
    authors: {
      type: Array,
      require: true,
      default: () => []
    },
    readingMediums: {
      type: Array,
      require: true,
      default: () => []
    },
    value: {
      type: Object,
      require: true,
      default: () => ({
        publisher: null,
        author: null,
        readingMedium: null,
        isbn: null
      })
    },
    addingProcess: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .dot > em {
  font-size: 16px !important;
}
</style>
